import React from "react";
import "./SubNavigation.css";

function SubNavigation({ activeSubTab, setActiveSubTab, subTabs }) {
  return (
    <div className="sub-navigation">
      {subTabs.map((tab) => (
        <button
          key={tab.id}
          className={
            tab.id === activeSubTab
              ? "sub-navigation__button sub-navigation__button-active"
              : "sub-navigation__button"
          }
          onClick={() => setActiveSubTab(tab.id)}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
}

export default SubNavigation;
